import React from "react";

import HGraph from "components/Custom/HGraph";

import { GRAPH_TYPES } from "common/config";

const BarGraph = (props: any) => {
  const { height, data } = props;

  const progress = data.progressChart;
  let categories = [];
  let series = [];
  let colors = ["#ffd216", "#e7803e", "#ff0000", "#2c8f00", "#379dd3"];

  series = progress.data.map((item) => {
    return item.data;
  });
  categories = progress.data.map((item) => {
    return item.name;
  });

  console.log("BarGraph: ", height);
  return (
    <React.Fragment>
      <div className="graphs">
        <HGraph
          width={"100%"}
          height={height}
          type={GRAPH_TYPES.BAR}
          float={"right"}
          xAxis={categories}
          yAxis={series}
          title={"Progress"}
          exportTitle={"Bar Graph Record "}
          xAxisTitle=""
          yAxisTitle=""
          // colors={colors}
        />
      </div>
    </React.Fragment>
  );
};

export default BarGraph;
